import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { VERSION } from "../../../environments/version";
import { AlertController, ModalController, Platform } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { auditTime, distinctUntilChanged, first, Subscription } from "rxjs";
import * as fromApp from "../../store/app.reducer";
import * as selectors from "../../store/app.selectors";
import * as _ from "lodash";
import { DataStorageService } from "src/app/services/data-storage/data-storage.service";
import { AnalyticsServiceService } from "src/app/services/analitycsService/analytics-service.service";
import * as CartActions from "../../cart/store/cart.actions";
import * as OrderCommentsActions from "../../cart/cart-components/order-comments/store/orderComments.actions";
import * as DisableFinalPriceActions from "../../store/disable-final-price/disable-final-price.actions";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import * as selectedInvoiceActions from "../../cart/cart-components/invoice/store/selectedInvoice.actions";
import * as DeliveryMethodAddressActions from "../../store/deliveryMethodAddress/deliveryMethodAddress.actions";
import * as CartCustomerOptionsActions from "../../../app/cart/cart-components/cart-custom-options/store/cart-customer-options/cart-customer-options.actions";
import * as CartCustomerOptionsSelectionsActions from "../../../app/cart/cart-components/cart-custom-options/store/cart-custom-options-selections/cart-custom-options-selections.actions";
import { LocalStorageDataService } from "src/app/services/local-storage-data/local-storage-data.service";
import { AnimationOptions } from "ngx-lottie";
import { CartPageAlertsService } from "src/app/services/cartPageAlerts/cart-page-alerts.service";
import { CreateOrderFailedPreorderModalComponent } from "../create-order-failed-preorder-modal/create-order-failed-preorder-modal.component";
import { Capacitor } from "@capacitor/core";
import { InformationMessagesService } from "src/app/services/informationMessages/information-messages.service";
import * as AuthActions from "../../auth/store/auth.actions";
import { MustConnectNetworkInfoModalComponent } from "../must-connect-network-info-modal/must-connect-network-info-modal.component";
import * as CartActiveCouponsActions from "../../cart/cart-components/cart-active-coupons/store/cartActiveCoupons.actions";
import * as CheckboxPromotionsActions from "../../cart/cart-components/checkbox-promotions/store/checkbox-promotions.actions";
import { buildPreorderRequestData } from "src/app/services/preorder-validation-service/preorder-delivery-visitor.helpers";
import { isGiftOnlyFreeOrder } from "src/app/services/gift-only-free-mode";
import { DineinTableLabelService } from "../../services/dinein-table-label/dinein-table-label.service";
import { DineinTableLabelContext } from "../../services/dinein-table-label/dinein-table-label.helpers";
import {
  getPartialPaymentPrices,
  PartialPaymentPrices,
} from "../../cart/cart-components/cart-prices/partial-payment-prices";
declare let window: any;

@Component({
  selector: "app-send-order-popup",
  templateUrl: "./send-order-popup.component.html",
  styleUrls: ["./send-order-popup.component.scss"],
})
export class SendOrderPopupComponent implements OnInit, OnDestroy {
  public orderPickup: any;
  public dineIn: any;
  public selectedAddress: any;
  public currentUser: any;
  public currentStoreId: any;
  public groupApp: any;
  public cartPrices: any;
  public partialPaymentPrices: PartialPaymentPrices | null = null;
  public checkBoxPromotions: any;
  public cartCustomOptions: any;
  public cart: any;
  public versionNumber: any;
  public customerInvoice: any;
  public migration_customer_id: any;
  public coupons: any;
  public selectedCoupons;
  public orderComments: any;
  public priorityScreenUsername: any;
  public generalComments: any;
  public selectedPaymentMethod: any;
  public mo_token: any;
  public device_id: any;
  public loading: boolean;
  public store_info: any;
  public version = VERSION.version;
  public selectedPreorderDate: any;
  public checkStoreOnlineInfo: any;
  public deliveryTimeIsNumber: boolean;
  public pickUpTimeIsNumber: boolean;
  public currentOrderPoints: any;
  public selectedLanguage: any;
  public selectedDineInTable: any;
  public createOrderLoadingAnimationInstance: any;
  public createOrderLoadingAnimation: boolean = false;
  public animateSendOrderButton: boolean = false;
  public createOrderModalInfoMessage;
  public mo_base;
  public carTakeAwayComments;
  public carTakeAwayPlateNumber;
  public expressDelivery;

  private developerMode: boolean;
  private subscription: Subscription;
  private storeInfoSubscription: Subscription;
  private createOrderRetried = false;
  private unsubscribeBackEvent: Subscription;
  private storesSub: Subscription;
  private localStorageService: LocalStorageDataService;
  private paymentSettlementPendingStorageKey =
    "paymentSettlementPendingSelected";

  animationOptions: AnimationOptions = {
    path: "https://data.deliverymanager.gr/animations/create-order-animation.json",
  };

  public dineinTableContext: DineinTableLabelContext = null;
  private dineinTableContextSub: Subscription;

  constructor(
    private modalController: ModalController,
    private store: Store<fromApp.AppState>,
    private dataStorageService: DataStorageService,
    private analyticsService: AnalyticsServiceService,
    private translate: TranslateService,
    private alertController: AlertController,
    private router: Router,
    private platform: Platform,
    private translateService: TranslateService,
    private infoMessagesService: InformationMessagesService,
    private cartPageAlertsService: CartPageAlertsService,
    private dineinTableLabelService: DineinTableLabelService
  ) {}

  ngOnInit() {
    this.dineinTableContextSub =
      this.dineinTableLabelService.context$.subscribe((context) => {
        this.dineinTableContext = context;
      });
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      200,
      () => {
        if (this.platform.is("android")) {
          this.closeModal();
        }
      }
    );
    this.storeInfoSubscription = this.store
      .select(selectors.getStoreInfo)
      .pipe(distinctUntilChanged())
      .subscribe((storeInfo) => {
        if (storeInfo && !_.isEqual(storeInfo, this.store_info)) {
          this.store_info = _.cloneDeep(storeInfo);
          console.log("store Info from cart options", this.store_info);
        }
      });

    this.storesSub = this.store
      .select("stores")
      .pipe(distinctUntilChanged())
      .pipe(auditTime(50))
      .subscribe((state) => {
        if (
          state &&
          state.checkStoreOnlineInfo &&
          !_.isEqual(state.checkStoreOnlineInfo, this.checkStoreOnlineInfo)
        ) {
          this.checkStoreOnlineInfo = _.cloneDeep(state.checkStoreOnlineInfo);

          if (
            this.checkStoreOnlineInfo &&
            this.checkStoreOnlineInfo.deliveryTime &&
            this.checkStoreOnlineInfo.deliveryTime
              .toString()
              .match(/^[0-9]+$/) != null
          ) {
            this.deliveryTimeIsNumber = true;
          } else {
            this.deliveryTimeIsNumber = false;
          }
          if (
            this.checkStoreOnlineInfo &&
            this.checkStoreOnlineInfo.pickupDeliveryTime &&
            this.checkStoreOnlineInfo.pickupDeliveryTime
              .toString()
              .match(/^[0-9]+$/) != null
          ) {
            this.pickUpTimeIsNumber = true;
          } else {
            this.pickUpTimeIsNumber = false;
          }
        }
      });

    this.subscription = this.store
      .pipe(distinctUntilChanged())
      .pipe(auditTime(100))
      .subscribe((state) => {
        if (
          state &&
          state.auth &&
          state.auth.user &&
          !_.isEqual(state.auth.user, this.currentUser)
        ) {
          this.currentUser = _.cloneDeep(state.auth.user);
        }
        if (
          state &&
          state.auth &&
          state.auth.migration_customer_id &&
          !_.isEqual(
            state.auth.migration_customer_id,
            this.migration_customer_id
          )
        ) {
          this.migration_customer_id = _.cloneDeep(
            state.auth.migration_customer_id
          );
        }
        if (
          state &&
          state.auth &&
          state.auth.mo_token &&
          !_.isEqual(state.auth.mo_token, this.mo_token)
        ) {
          this.mo_token = _.cloneDeep(state.auth.mo_token);
        }
        if (
          state &&
          state.platformInfo &&
          !_.isEqual(state.platformInfo.device_id, this.device_id)
        ) {
          this.device_id = _.cloneDeep(state.platformInfo.device_id);
        }
        if (
          state &&
          state.cartCustomerOptions &&
          _.isArray(state.cartCustomerOptions.cartCustomerOptions) &&
          !_.isEqual(
            state.cartCustomerOptions.cartCustomerOptions,
            this.cartCustomOptions
          )
        ) {
          this.cartCustomOptions = _.cloneDeep(
            state.cartCustomerOptions.cartCustomerOptions
          );
          this.expressDelivery = null;
          const express_delivery = _.find(_.cloneDeep(this.cartCustomOptions), {
            preNameId: "express_delivery",
          });

          if (
            !_.isEmpty(express_delivery) &&
            express_delivery.choices &&
            express_delivery.choices[0] &&
            express_delivery.choices[0].selected &&
            express_delivery.choices[0].qty === 1
          ) {
            this.expressDelivery =
              this.translateService.instant("with-priority") +
              " " +
              express_delivery.choices[0].title;
          }
        }
        if (
          state &&
          state.deliveryMethodAddress &&
          !_.isEqual(state.deliveryMethodAddress.orderPickup, this.orderPickup)
        ) {
          this.orderPickup = _.cloneDeep(
            state.deliveryMethodAddress.orderPickup
          );
        }
        if (
          state &&
          state.deliveryMethodAddress &&
          !_.isEqual(
            state.deliveryMethodAddress.selectedDineInTable,
            this.selectedDineInTable
          )
        ) {
          this.selectedDineInTable = _.cloneDeep(
            state.deliveryMethodAddress.selectedDineInTable
          );
        }

        if (
          state &&
          state.deliveryMethodAddress &&
          !_.isEqual(
            state.deliveryMethodAddress.carTakeAwayComments,
            this.carTakeAwayComments
          )
        ) {
          this.carTakeAwayComments = _.cloneDeep(
            state.deliveryMethodAddress.carTakeAwayComments
          );
        }

        if (
          state &&
          state.deliveryMethodAddress &&
          !_.isEqual(
            state.deliveryMethodAddress.carTakeAwayPlateNumber,
            this.carTakeAwayPlateNumber
          )
        ) {
          this.carTakeAwayPlateNumber = _.cloneDeep(
            state.deliveryMethodAddress.carTakeAwayPlateNumber
          );
        }

        if (
          state &&
          state.deliveryMethodAddress &&
          !_.isEqual(state.deliveryMethodAddress.dineIn, this.dineIn)
        ) {
          this.dineIn = _.cloneDeep(state.deliveryMethodAddress.dineIn);
        }
        if (
          state &&
          state.currentStore &&
          state.currentStore.currentStoreId &&
          !_.isEqual(state.currentStore.currentStoreId, this.currentStoreId)
        ) {
          this.currentStoreId = _.cloneDeep(state.currentStore.currentStoreId);
        }
        if (
          state &&
          state.deliveryMethodAddress &&
          state.deliveryMethodAddress.selectedAddress &&
          !_.isEqual(
            state.deliveryMethodAddress.selectedAddress,
            this.selectedAddress
          )
        ) {
          this.selectedAddress = _.cloneDeep(
            state.deliveryMethodAddress.selectedAddress
          );
        }
        if (
          state &&
          state.groupApp &&
          state.groupApp.groupApp &&
          !_.isEqual(state.groupApp.groupApp, this.groupApp)
        ) {
          this.groupApp = _.cloneDeep(state.groupApp.groupApp);

          this.store
            .select(selectors.getStoreInfo)
            .pipe(first())
            .subscribe((store_info) => {
              if (store_info) {
                const infoMessagesGroup =
                  this.infoMessagesService.checkForMobileOrderInfoMessagesGroupApp(
                    this.groupApp,
                    store_info,
                    "completeOrderModal"
                  );

                const infoMessagesStore =
                  this.infoMessagesService.checkForMobileOrderInfoMessagesGroupApp(
                    this.groupApp,
                    store_info,
                    "completeOrderModal"
                  );

                if (infoMessagesStore && infoMessagesStore.length) {
                  this.createOrderModalInfoMessage = infoMessagesStore[0];
                } else {
                  if (infoMessagesGroup && infoMessagesGroup.length) {
                    this.createOrderModalInfoMessage = infoMessagesGroup[0];
                  }
                }
              }
            })
            .unsubscribe();

          this.mo_base = _.cloneDeep(
            _.find(this.groupApp.languages, {
              mo_base: true,
            })
          );
          if (!this.mo_base) {
            this.mo_base = "en";
          } else {
            this.mo_base = this.mo_base.code;
          }

          if (this.groupApp.design_settings) {
            if (this.groupApp.design_settings.animation_loader) {
              this.animationOptions = {
                ...this.animationOptions,
                path:
                  "https://data.deliverymanager.gr/animations/" +
                  this.groupApp.design_settings.animation_loader,
              };
            } else {
              this.animationOptions = {
                ...this.animationOptions,
                path: "https://data.deliverymanager.gr/animations/spinner-default-1.json",
              };
            }
          } else {
            this.animationOptions = {
              ...this.animationOptions,
              path: "https://data.deliverymanager.gr/animations/spinner-default-1.json",
            };
          }
        }
        if (
          state &&
          state.groupApp &&
          state.groupApp.selectedLangugage &&
          !_.isEqual(state.groupApp.selectedLangugage, this.selectedLanguage)
        ) {
          this.selectedLanguage = _.cloneDeep(state.groupApp.selectedLangugage);
        }
        if (
          state &&
          state.checkboxPromotions &&
          state.checkboxPromotions.checkboxPromotions &&
          !_.isEqual(
            state.checkboxPromotions.checkboxPromotions,
            this.checkBoxPromotions
          )
        ) {
          this.checkBoxPromotions = _.cloneDeep(
            state.checkboxPromotions.checkboxPromotions
          );
        }
        const partialPaymentPrices = getPartialPaymentPrices(
          state?.cartPrices?.cartPrices
        );
        if (!_.isEqual(this.partialPaymentPrices, partialPaymentPrices)) {
          this.partialPaymentPrices = _.cloneDeep(partialPaymentPrices);
        }
        if (
          state &&
          state.cartPrices &&
          state.cartPrices.cartPrices &&
          !_.isEqual(state.cartPrices.cartPrices, this.cartPrices)
        ) {
          this.cartPrices = _.cloneDeep(state.cartPrices.cartPrices);

          if (this.cartPrices && this.cartPrices.currentOrderPoints) {
            this.currentOrderPoints = _.cloneDeep(
              this.cartPrices.currentOrderPoints
            );
          }
        }
        if (
          state &&
          state.cart &&
          state.cart.products &&
          !_.isEqual(state.cart.products, this.cart)
        ) {
          this.cart = _.cloneDeep(state.cart.products);
        }
        if (
          state &&
          state.orderComments &&
          state.orderComments.generalComments &&
          !_.isEqual(state.orderComments.generalComments, this.orderComments)
        ) {
          this.orderComments = _.cloneDeep(state.orderComments.generalComments);
        }
        if (
          state &&
          state.orderComments &&
          !_.isEqual(
            state.orderComments.priorityScreenUsername,
            this.priorityScreenUsername
          )
        ) {
          this.priorityScreenUsername = _.cloneDeep(
            state.orderComments.priorityScreenUsername
          );
        }
        if (
          state &&
          state.selectedInvoice &&
          state.selectedInvoice.selectedInvoice &&
          !_.isEqual(state.selectedInvoice, this.customerInvoice)
        ) {
          this.customerInvoice = _.cloneDeep(
            state.selectedInvoice.selectedInvoice
          );
        }
        if (
          state &&
          state.cartActiveCoupons &&
          state.cartActiveCoupons.activeCoupons &&
          !_.isEqual(state.cartActiveCoupons.activeCoupons, this.coupons)
        ) {
          this.coupons = _.cloneDeep(state.cartActiveCoupons.activeCoupons);
          if (this.coupons && this.coupons.length) {
            this.selectedCoupons = _.filter(this.coupons, {
              couponCheckbox: true,
            });
          }
        }
        if (
          state.selectedPaymentMethodID &&
          state.selectedPaymentMethodID.selectedPaymentMethodID &&
          !_.isEqual(
            state.selectedPaymentMethodID.selectedPaymentMethodID,
            this.selectedPaymentMethod
          )
        ) {
          this.selectedPaymentMethod = _.cloneDeep(
            state.selectedPaymentMethodID.selectedPaymentMethodID
          );
        }
        if (
          state.deliveryMethodAddress &&
          state.deliveryMethodAddress.selectedPreorderDate &&
          !_.isEqual(
            state.deliveryMethodAddress.selectedPreorderDate,
            this.selectedPreorderDate
          )
        ) {
          this.selectedPreorderDate = _.cloneDeep(
            state.deliveryMethodAddress.selectedPreorderDate
          );
          console.log("selected preorder date", this.selectedPreorderDate);
        }
        if (
          state.developerMode &&
          state.developerMode.developerMode &&
          !_.isEqual(state.developerMode.developerMode, this.developerMode)
        ) {
          this.developerMode = _.cloneDeep(state.developerMode.developerMode);
        }
      });

    setTimeout(() => {
      if (!this.animateSendOrderButton) {
        this.animateSendOrderButton = true;
      }
    }, 500);
  }

  toFloat(num) {
    console.log("toFloat", num);
    if (num) {
      const stringNumb = num.toString();
      console.log("stringNum", parseFloat(stringNumb).toFixed(2));
      return parseFloat(stringNumb).toFixed(2);
    } else {
      return 0;
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }

  // sendOrderSuccess() {
  //   this.loading = true;
  //   setTimeout(() => {
  //     this.presentOrderCompletedAlert();
  //     this.router.navigateByUrl("/orders");
  //     this.closeModal();
  //   }, 500);
  // }

  // sendOrderFailed() {
  //   this.loading = true;
  //   setTimeout(() => {
  //     this.presentErrorOnCompleteOrderAlert();
  //   }, 500);
  // }

  // presentAlertsTest() {
  //   this.presentErrorOnCompleteOrderAlert("test test test");
  //   this.presentOrderCompletedAlert();
  // }

  sendOrder() {
    let platform = "browser";
    if (!Capacitor.isNativePlatform() && this.inIframe()) {
      platform = "facebook";
    } else if (Capacitor.isNativePlatform()) {
      platform = Capacitor.getPlatform();
    }
    var selectedCoupons = _.filter(this.coupons, {
      couponCheckbox: true,
    });
    console.log("coupppp", selectedCoupons, this.coupons);
    this.loading = true;
    this.createOrderLoadingAnimation = true;
    const langs = _.cloneDeep(this.groupApp.languages);
    let baseLanguage;
    const moBaseLanguage = _.find(langs, { mo_base: true });
    if (moBaseLanguage && moBaseLanguage.code) {
      baseLanguage = moBaseLanguage.code;
    }
    this.dataStorageService
      .createOrder(
        _.extend(
          {
          store_id: this.currentStoreId,
          firstName: this.currentUser.firstName,
          lastName: this.currentUser.lastName,
          group: this.currentUser.group,
          selectedLanguage: this.selectedLanguage,
          baseLanguage: baseLanguage || "el",
          generalComments: this.orderComments, //Comments for ORDER
          priorityScreenUsername: this.priorityScreenUsername,
          pickup: this.orderPickup,
          dinein: this.dineIn,
          dinein_table_id:
            this.selectedDineInTable && this.selectedDineInTable.table_id
              ? this.selectedDineInTable.table_id
              : null,
          dinein_table_name:
            this.selectedDineInTable && this.selectedDineInTable.name
              ? this.selectedDineInTable.name
              : null,
          deliveryCost: this.cartPrices.deliveryCost,
          versionNumber: this.version,
          checkboxPromotions: this.checkBoxPromotions,
          cartCustomOptions: _.isArray(this.cartCustomOptions)
            ? this.cartCustomOptions
            : [],
          coupons: selectedCoupons,
          cart: this.cart,
          customerInvoice:
            this.store_info.customerInvoice && this.customerInvoice
              ? this.customerInvoice
              : {},
          paymentTimestamp: "",
          address_id:
            this.orderPickup || this.dineIn
              ? ""
              : this.selectedAddress.address_id,
          address_unverified:
            this.orderPickup || this.dineIn
              ? false
              : this.selectedAddress.unverified,
          floor:
            this.orderPickup || this.dineIn ? "" : this.selectedAddress.floor,
          company:
            this.orderPickup || this.dineIn ? "" : this.selectedAddress.company,
          company_manager:
            this.orderPickup || this.dineIn
              ? ""
              : this.selectedAddress.company_manager,
          comments:
            this.orderPickup || this.dineIn
              ? ""
              : this.selectedAddress.comments,
          userLat:
            this.orderPickup || this.dineIn ? "" : this.selectedAddress.userLat,
          userLng:
            this.orderPickup || this.dineIn ? "" : this.selectedAddress.userLng,
          formatted_address:
            this.orderPickup || this.dineIn
              ? ""
              : this.selectedAddress.formatted_address,
          postCode:
            this.orderPickup || this.dineIn
              ? ""
              : this.selectedAddress &&
                this.selectedAddress.address_components &&
                this.selectedAddress.address_components.postal_code
              ? this.selectedAddress.address_components.postal_code
              : null,
          doorbellname:
            this.orderPickup || this.dineIn
              ? ""
              : this.selectedAddress.doorbellname,
          altPhone:
            this.orderPickup || this.dineIn
              ? ""
              : this.selectedAddress.altPhone,
          platform: platform,
          timezone: this.store_info.timezone || "Europe/Athens",
          ...buildPreorderRequestData(
            this.currentUser,
            this.selectedPreorderDate
          ),
          preorderAcceptDisableDeliveryTime:
            this.selectedPreorderDate &&
            this.selectedPreorderDate.preorderAcceptDisableDeliveryTime
              ? true
              : false,
          preorderAcceptDisablePickupTime:
            this.selectedPreorderDate &&
            this.selectedPreorderDate.preorderAcceptDisablePickupTime
              ? true
              : false,
          migration_customer_id:
            this.store_info && this.store_info.vatBasedCustomerProductsActive
              ? this.migration_customer_id
              : null,
          channel: this.developerMode ? "mastercapacitorv7" : "CapacitorV7",
          device_id: this.device_id ? this.device_id : undefined,
          },
          this.getCreateOrderPaymentMethodPayload(this.selectedPaymentMethod)
        ),
        this.mo_token
      )
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.analyticsService.fbqTrackPurchase(
              this.cartPrices.grand_total,
              this.cart
            );

            this.analyticsService.tikTokPixelPurchase(
              this.cart,
              this.cartPrices.grand_total
            );

            this.analyticsService.logEventPurchase(
              res.orderItem.order_id,
              res.orderItem.grand_total
            );
            this.analyticsService.dmAnalyticsMessage(
              "complete_order_success",
              null,
              null,
              null,
              null,
              res.orderItem.order_id,
              null,
              null,
              null,
              null,
              null
            );

            this.createOrderRetried = false;
            this.loading = false;
            this.createOrderLoadingAnimation = false;

            this.cartPageAlertsService.clearPendingOrderAlertAlreadyShowedInCompleteOrder();
            this.store.dispatch(new CartActions.ClearCart());
            this.store.dispatch(
              new selectedInvoiceActions.ClearSelectedInvoice()
            );
            this.store.dispatch(
              new DeliveryMethodAddressActions.setSelectedPreorderDate(null)
            );
            this.store.dispatch(
              new OrderCommentsActions.SetOrderComments(null)
            );
            this.store.dispatch(
              new OrderCommentsActions.SetOrderPriorityScreenUsername(null)
            );

            this.store.dispatch(
              new CartActiveCouponsActions.SetActiveCoupons(null)
            );
            this.store.dispatch(
              new CheckboxPromotionsActions.SetCheckboxPromotions([])
            );
            if (
              (!this.orderPickup &&
                !this.dineIn &&
                this.selectedAddress &&
                this.selectedAddress.fixed_address_id) ||
              (this.orderPickup === false && this.dineIn === true)
            ) {
              //clear delivery method state on fixed address OR on dine in order!!!
              if (!this.currentUser?.uposMoUser) {
                this.clearDeliveryMethod();
              }
            }

            if (navigator.cookieEnabled) {
              window.localStorage.removeItem("cart");
              window.localStorage.removeItem("cartCustomOptions");
              window.localStorage.removeItem("checkboxPromotions");
              if (localStorage.getItem("orderComments")) {
                localStorage.removeItem("orderComments");
              }
            }
            this.store.dispatch(
              new CartCustomerOptionsActions.ClearCartCustomerOptions()
            );

            this.store.dispatch(
              new CartCustomerOptionsSelectionsActions.ClearCartCustomOptionsSelections()
            );
            if (
              this.store_info &&
              this.store_info.cartCustomOptions &&
              this.store_info.cartCustomOptions.length > 0
            ) {
              let customOptions = _.cloneDeep(
                this.store_info.cartCustomOptions
              );
              customOptions.forEach((option) => {
                this.store.dispatch(
                  new CartCustomerOptionsSelectionsActions.AddUpdateCartCustomOptionSelections(
                    option
                  )
                );
              });
            }

            if (res.updatedCustomer && !_.isEmpty(res.updatedCustomer)) {
              this.store.dispatch(
                new AuthActions.SetUser(_.cloneDeep(res.updatedCustomer))
              );
            }
            //TO_DO CHECK IF YOU WANT TO PRINT COMMENT_ID
            this.closeModal();

            if (
              !this.currentUser ||
              (!this.currentUser.only_dinein && !this.currentUser.only_visitor)
            ) {
              this.presentOrderCompletedAlert();
            }

            if (
              this.currentUser &&
              (this.currentUser.only_dinein ||
                this.currentUser.only_visitor ||
                this.currentUser.uposMoUser)
            ) {
              this.router.navigateByUrl(
                this.getCreateOrderOrdersRedirectUrl(res.orderItem),
                {
                  replaceUrl: true,
                }
              );
            } else {
              this.router.navigateByUrl("/orders", {
                replaceUrl: true,
              });
            }
          } else if (!res.success && res.retry && !this.createOrderRetried) {
            this.analyticsService.dmAnalyticsMessage(
              "complete_order_failed",
              res.comment_id,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            );
            this.createOrderRetried = true;
            setTimeout(() => {
              this.sendOrder();
            }, 20000);
          } else {
            this.loading = false;
            this.createOrderLoadingAnimation = false;

            this.createOrderRetried = false;
            this.store.dispatch(
              new DisableFinalPriceActions.SetTriggerFinalPriceTimestamp(
                Date.now().toString()
              )
            );

            if (res.comment_id === "prompt_for_preorder") {
              this.modalController.dismiss();
              this.presentPreorderInfoModal();
            } else if (
              res.comment_id ===
              "the-selected-payment-method-is-must-connect-to-network"
            ) {
              this.presentMustConnectToNetworkInfoModal();
            } else {
              if (res.comment_id) {
                // 86cb07qhh: new_customer_cash_cap is the cap the SERVER actually
                // enforced, so the rejection message renders the real amount
                // instead of the app carrying its own copy of the default.
                this.presentErrorAlert(
                  res.comment_id,
                  res.new_customer_cash_cap
                );
              } else {
                this.presentErrorAlert(res.comments);
              }
            }

            this.analyticsService.dmAnalyticsMessage(
              "complete_order_failed",
              res.comment_id,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            );
          }
            },
            error: (error) => {
          console.log("Error on sending order: ", error);

          if (!this.createOrderRetried) {
            this.analyticsService.dmAnalyticsMessage(
              "complete_order_failed",
              "create_order_failed_will_retry",
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            );
            this.createOrderRetried = true;

            setTimeout(() => {
              this.sendOrder();
            }, 5000);
          } else {
            this.analyticsService.dmAnalyticsMessage(
              "complete_order_failed",
              "create_order_failed_after_retry",
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            );
            this.createOrderRetried = false;
            this.loading = false;
            this.createOrderLoadingAnimation = false;
            this.presentErrorAlert(
              "errorMessages.sending-you-order-failed-please-try-again"
            );
          }
        },
      });
  }

  async presentPreorderInfoModal() {
    const modal = await this.modalController.create({
      component: CreateOrderFailedPreorderModalComponent,
      cssClass: "create-order-failed-preorder-modal",
      backdropDismiss: false,
    });
    await modal.present();
  }

  async presentMustConnectToNetworkInfoModal() {
    const modal = await this.modalController.create({
      component: MustConnectNetworkInfoModalComponent,
      cssClass: "must-connect-network-info-modal",
      backdropDismiss: false,
      componentProps: {
        storeWifiNetworkName: this.store_info.storeWifiNetworkName,
        storeWifiNetworkPassword: this.store_info.storeWifiNetworkPassword,
        currentUser: this.currentUser,
      },
    });
    await modal.present();
  }

  async presentOrderCompletedAlert() {
    const alert = await this.alertController.create({
      cssClass: "orderCompletedAlert",
      header: this.translate.instant("order-success"),

      buttons: [
        {
          text: "OK",
          role: "cancel",
          cssClass: "completedOrderAlertButton",
          handler: (blah) => {
            alert.dismiss();
          },
        },
      ],
    });

    await alert.present();
  }
  async presentErrorOnCompleteOrderAlert(message) {
    const alert = await this.alertController.create({
      cssClass: "errorOnOrderCompletedAlert",
      header: this.translate.instant("order-failed"),
      message: this.translate.instant(message),

      buttons: [
        {
          text: "OK",
          role: "cancel",
          cssClass: "completedOrderAlertButton",
          handler: (blah) => {
            alert.dismiss();
          },
        },
      ],
    });

    await alert.present();
  }

  async presentErrorAlert(message, newCustomerCashCap?) {
    const alert = await this.alertController.create({
      cssClass: "errorOnOrderCompletedAlert",
      header: this.translate.instant("errorMessages.alert"),

      message: this.getErrorAlertMessage(message, newCustomerCashCap),
      buttons: ["OK"],
    });

    await alert.present();
  }

  // Create-order server error codes (res.comment_id) are translated under the
  // errorMessages namespace (e.g. cash_not_allowed_for_new_customer). When the
  // raw code is not a top-level key, fall back to errorMessages.<code> so it is
  // never shown to the user as a raw code.
  private resolveErrorAlertMessage(message): string {
    const direct = this.dineinTableLabelService.instant(message);
    if (direct && direct !== message) {
      return direct;
    }
    const namespacedKey = "errorMessages." + message;
    const namespaced = this.dineinTableLabelService.instant(namespacedKey);
    return namespaced && namespaced !== namespacedKey ? namespaced : direct;
  }

  private getErrorAlertMessage(
    message: string,
    newCustomerCashCap?: any
  ): string {
    // 86cb07qhh: the new-customer cash rejection explains WHY cash was refused
    // and names the cap the server enforced. The amount comes from the response
    // (new_customer_cash_cap), never from a client-side copy of the default,
    // which drifted 20->500->20 during 86cam7xu0. Without an amount the message
    // still renders — the key's fallback text carries no {{amount}}.
    if (message === "cash_over_new_customer_max_amount") {
      if (_.isNil(newCustomerCashCap) || newCustomerCashCap === "") {
        return this.resolveErrorAlertMessage(message);
      }

      const formattedCap =
        this.store_info && this.store_info.showPricesWithComma
          ? newCustomerCashCap.toString().replace(/\./g, ",")
          : newCustomerCashCap;

      return this.translate.instant(
        "errorMessages.cash_over_new_customer_max_amount_with_amount",
        {
          amount: formattedCap,
          currencySymbol:
            this.store_info && this.store_info.currencySymbol
              ? this.store_info.currencySymbol
              : "€",
        }
      );
    }

    if (
      message !== "the-selected-payment-method-is-over-mo-max-amount" &&
      message !== "the-selected-payment-method-is-under-mo-min-amount"
    ) {
      return this.resolveErrorAlertMessage(message);
    }

    const gatewayAmount = _.get(
      this.store_info,
      [
        "paymentGateways",
        this.selectedPaymentMethod,
        message === "the-selected-payment-method-is-under-mo-min-amount"
          ? "mo_min_amount"
          : "mo_max_amount",
      ],
      null
    );

    if (_.isNil(gatewayAmount) || gatewayAmount === "") {
      return this.translate.instant(message);
    }

    const formattedAmount =
      this.store_info && this.store_info.showPricesWithComma
        ? gatewayAmount.toString().replace(/\./g, ",")
        : gatewayAmount;

    return this.translate.instant(
      message === "the-selected-payment-method-is-under-mo-min-amount"
        ? "cart.cart-components.payment-methods.gateway-min-amount-message"
        : "cart.cart-components.payment-methods.gateway-max-amount-message",
      {
        amount: formattedAmount,
        currencySymbol:
          this.store_info && this.store_info.currencySymbol
            ? this.store_info.currencySymbol
            : "€",
      }
    );
  }

  clearDeliveryMethod() {
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedAddress(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setValidStores(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setValidDeliveryAreas(_.cloneDeep(null))
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setOpenNotValidAddressModal(false)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setOpenSelectStorePopupDelivery(false)
    );
    this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(null));
    this.store.dispatch(new DeliveryMethodAddressActions.setOrderPickup(null));
    this.store.dispatch(
      new DeliveryMethodAddressActions.setSelectedDineInTable(null)
    );

    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
    );
    this.store.dispatch(
      new DeliveryMethodAddressActions.setCarTakewayComments(null)
    );

    if (navigator.cookieEnabled) {
      let deliveryMethodAddressObj: any = localStorage.getItem(
        "deliveryMethodAddress"
      );
      if (deliveryMethodAddressObj) {
        deliveryMethodAddressObj = JSON.parse(deliveryMethodAddressObj);
        deliveryMethodAddressObj.dineIn = null;
        deliveryMethodAddressObj.orderPickup = null;
        deliveryMethodAddressObj.selectedAddress = null;
        deliveryMethodAddressObj.selectedDineInTable = null;
        deliveryMethodAddressObj.carTakeAwayPlateNumber = null;
        deliveryMethodAddressObj.carTakeAwayComments = null;

        localStorage.setItem(
          "deliveryMethodAddress",
          JSON.stringify(deliveryMethodAddressObj)
        );
      }
    }
  }

  private getCreateOrderPaymentMethodPayload(selectedPaymentMethodID: string) {
    //ClickUp 86canwpzx - the cart was shown as free, so the order goes in as cash and
    //the store absorbs the wrapper tax. create-order enforces the same rule.
    if (
      isGiftOnlyFreeOrder(this.store_info, this.cart, this.cartPrices) &&
      !this.isOfflinePaymentMethod(selectedPaymentMethodID)
    ) {
      return {
        selectedPaymentMethodID: "cash",
      };
    }

    if (!this.shouldSendPaymentSettlementPending(selectedPaymentMethodID)) {
      return {
        selectedPaymentMethodID,
      };
    }

    return {
      selectedPaymentMethodID: "cash",
      paymentSettlementPending: true,
    };
  }

  private getCreateOrderOrdersRedirectUrl(orderItem) {
    const ordersUrl = "/orders?createOrder=true";
    if (
      !this.currentUser?.uposMoUser ||
      this.currentUser?.only_dinein ||
      !orderItem ||
      !orderItem.order_id ||
      !orderItem.store_id
    ) {
      return ordersUrl;
    }

    return `${ordersUrl}&createdOrderId=${encodeURIComponent(
      orderItem.order_id
    )}&createdStoreId=${encodeURIComponent(orderItem.store_id)}`;
  }

  private isOfflinePaymentMethod(paymentMethodId: string) {
    return (
      paymentMethodId === "cash" ||
      paymentMethodId === "mobilePOS" ||
      paymentMethodId === "pre_cash" ||
      paymentMethodId === "pre_mobilePOS"
    );
  }

  private shouldSendPaymentSettlementPending(
    selectedPaymentMethodID: string
  ) {
    return !!(
      selectedPaymentMethodID === "cash" &&
      this.currentUser?.uposMoUser &&
      this.store_info?.paymentGateways?.cash?.paymentSettlementPending &&
      navigator.cookieEnabled &&
      window.localStorage.getItem(this.paymentSettlementPendingStorageKey) ===
        "true"
    );
  }

  animationCreated(ev) {
    this.createOrderLoadingAnimationInstance = ev;
    this.createOrderLoadingAnimationInstance.setSpeed(1);
  }

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  ngOnDestroy() {
    if (this.dineinTableContextSub) {
      this.dineinTableContextSub.unsubscribe();
    }
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.storeInfoSubscription) {
      this.storeInfoSubscription.unsubscribe();
    }
    if (this.storesSub) {
      this.storesSub.unsubscribe();
    }
  }
}
